import React from "react"
import FacebookIcon from "@material-ui/icons/Facebook"
import LinkedInIcon from "@material-ui/icons/LinkedIn"

const siteMetadata = require("../data/site-metadata.json")
const socialIcons = {
  facebook: FacebookIcon,
  linkedin: LinkedInIcon,
}
const socialLabels = { facebook: "Facebook", linkedin: "LinkedIn" }

type SocialProfile = {
  name: keyof typeof socialIcons
  url: string
}

const Footer = () => (
  <footer className="footer">
    <div className="footer-inner">
      <div className="footer-brand">
        <a href="/" className="footer-name">
          School Calendar
        </a>
        <span className="footer-copyright">© {new Date().getFullYear()}</span>
      </div>
      <nav className="footer-links" aria-label="Footer">
        <a href="/guides/">Guides</a>
        <a href="/about/">About</a>
        <a href="/editorial-policy/">Editorial</a>
        {siteMetadata.social.map((profile: SocialProfile) => {
          const Icon = socialIcons[profile.name]
          if (!Icon) return null
          return (
            <a key={profile.name} href={profile.url}>
              <Icon fontSize="small" />
              {socialLabels[profile.name]}
            </a>
          )
        })}
      </nav>
    </div>
  </footer>
)

export default Footer
